var _classCallCheck = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/createClass");

/**
* Our own wrapper for AsyncStorage
*/
var React = window.React = require('react');

var Config = window.Config = require('../../../../config');

var IS_MOBILE = Config.PLATFORM == "react-native";
var storageComponent = window.storageComponent = Config.STORAGE ? Config.STORAGE : localStorage;

var Utils = window.Utils = require('../cl-utils');

var TAG = 'CLStorage';
var RESPONSE_STORAGE_PREFIX = '@response-key-';
var LOGIN_CRED_STORAGE_PREFIX = '@login-cred-key';

var CLStorage =
/*#__PURE__*/
function () {
  "use strict";

  function CLStorage() {
    _classCallCheck(this, CLStorage);
  }

  _createClass(CLStorage, null, [{
    key: "storeResponse",

    /**
    * Store an API response in local storage
    * @param  {string} requestUrl    the request url
    * @param  {string} type          POST or GET
    * @param  {object} requestConfig request config object
    * @param  {object} data          response data
    * @return {Promise}
    */
    value: function storeResponse(requestUrl, type, requestConfig, data) {
      var key = CLStorage._generateResponseStorageKey(requestUrl, type, requestConfig);

      var cache = {
        data: data,
        requestConfig: requestConfig,
        timestamp: new Date().getTime()
      }; //console.log(TAG, '_storeResponse', 'storing key', key, 'data', cache);

      console.log(TAG, " _storeResponse", 'storing key', key, 'data', cache);

      if (IS_MOBILE) {
        return storageComponent.setItem(key, JSON.stringify(cache));
      } else {
        return new Promise(function (resolve, reject) {
          resolve(storageComponent.setItem(key, JSON.stringify(cache)));
        });
      }
    }
    /**
    * Fetch an API response from local storage
    * @param  {string} requestUrl
    * @param  {string} type          POST or GET
    * @param  {object} requestConfig
    * @return {Promise}
    */

  }, {
    key: "fetchResponse",
    value: function fetchResponse(requestUrl, type, requestConfig) {
      var key = CLStorage._generateResponseStorageKey(requestUrl, type, requestConfig); //return storageComponent.getItem(key);


      if (IS_MOBILE) {
        return storageComponent.getItem(key);
      } else {
        return new Promise(function (resolve, reject) {
          resolve(storageComponent.getItem(key));
        });
      }
    }
    /**
    * Store login creds in local storage
    * @param  {string} type   email|facebook|google|etc.
    * @param  {object} params based on type
    *                 (e.g. email object is { email: <email>, password: <password>})
    * @return {Promise}
    */

  }, {
    key: "storeLoginCredentials",
    value: function storeLoginCredentials(type, params) {
      var key = LOGIN_CRED_STORAGE_PREFIX;
      var value = JSON.stringify({
        type: type,
        params: params
      });
      console.log(TAG, '_storeLoginCredentials, storing', value);
      console.log(TAG, '_storeLoginCredentials, storing key', key, "value", value);
      return storageComponent.setItem(key, value);
    }
    /**
    * Fetch login credentials from local storage
    * @return {Promise}
    */

  }, {
    key: "fetchLoginCredentials",
    value: function fetchLoginCredentials() {
      var key = LOGIN_CRED_STORAGE_PREFIX;
      console.log(";;", storageComponent.getItem(key));
      console.log(storageComponent);

      if (IS_MOBILE) {
        return storageComponent.getItem(key);
      } else {
        console.log("returning keys: ", storageComponent.getItem(key));
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            console.log("delayed storage creds key: " + key + ", val: " + storageComponent.getItem(key));
            resolve(storageComponent.getItem(key));
          }, 1000);
        });
      }
    }
    /**
    * Clear login credentials from local storage
    * @return {Promise}
    */

  }, {
    key: "clearLoginCredentials",
    value: function clearLoginCredentials() {
      var key = LOGIN_CRED_STORAGE_PREFIX;
      return storageComponent.removeItem(key);
    }
    /**
    * Generates a local storage (cache) unique key
    * @return {string}        a unique key based on the method, request type, and request body
    */

  }, {
    key: "_generateResponseStorageKey",
    value: function _generateResponseStorageKey(requestUrl, type, requestConfig) {
      var k = RESPONSE_STORAGE_PREFIX + ':' + requestUrl + ':' + type + ':' + JSON.stringify(requestConfig);
      var hash = Utils.md5(k);
      return hash;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return storageComponent.setItem(key, value);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      if (IS_MOBILE) {
        return storageComponent.getItem(key);
      } else {
        //console.log("returning keys: ",storageComponent.getItem(key));
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            //console.log("delayed storage creds key: "+key+", val: "+storageComponent.getItem(key));
            resolve(storageComponent.getItem(key));
          }, delay);
        });
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return storageComponent.removeItem(key);
    }
  }]);

  return CLStorage;
}();

module.exports = CLStorage;